/* eslint-disable camelcase */
/* eslint-disable import/no-unresolved */
import React, {
  useContext, useState, useEffect, useRef,
} from 'react';
import * as L from 'leaflet';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { urls, swalMessages } from 'src/constants';
import MapasPage from 'src/pages/PolygonsPage/MapaPage/MapaPage';
import mapsService from 'src/services/mapsService';
import polygonsService from 'src/services/polygonsService';
import { Context } from 'src/context/Contex';

const MapasContainer = () => {
  const [zonas, setZona] = useState([]);
  const [update, setUpdate] = useState(false);
  const [check, setCheck] = useState(false);
  const [month, setMonth] = useState(1);
  const [colombia, setColombia] = useState([]);
  const [show, setShow] = useState({ show: false, isDelete: false });
  const [calculos, setCalculos] = useState([]);
  const [estadistica, setEstadistica] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [consolidate, setConsolidate] = useState([]);
  const { unidad, permisos } = useContext(Context);
  const mapRef = useRef(null);
  const history = useHistory();

  /*= =======================================================================
  Get Zonas
======================================================================== */
  const getZones = () => {
    polygonsService
      .getZonas(unidad)
      .then((response) => {
        setZona(response.data.data);
      })
      .catch(() => {
        history.push('/home');
      });
  };

  const getColombia = async () => {
    const response = await mapsService.getColombia();
    if (response) {
      setColombia(response);
    }
  };

  const getCalculos = async (value) => {
    const NewCalculos = [];
    const response = await mapsService.getCalculos(value || month, unidad);
    if (Array.isArray(response)) {
      response.forEach((d) => {
        NewCalculos.push({
          ...d,
          SUM_P: parseInt(d?.CANTIDAD_DE_PERSONAS?.split(' ')[0] || 0, 10) || 0,
          SUM_AUTECO: parseInt(d?.AUTECO?.split(' ')[0] || 0, 10) || 0,
          SUM_SUZUKI: parseInt(d?.SUZUKI?.split(' ')[0] || 0, 10) || 0,
          SUM_HERO: parseInt(d?.HERO?.split(' ')[0] || 0, 10) || 0,
          SUM_HONDA: parseInt(d?.HONDA?.split(' ')[0] || 0, 10) || 0,
          SUM_MOBILITY: parseInt(d?.MOBILITY?.split(' ')[0] || 0, 10) || 0,
          SUM_OTROS: parseInt(d?.OTRAS?.split(' ')[0] || 0, 10) || 0,
          SUM_AKT: parseInt(d?.AKT?.split(' ')[0] || 0, 10) || 0,
          SUM_YAMAHA: parseInt(d?.YAMAHA?.split(' ')[0] || 0, 10) || 0,
          SUM_UMA: parseInt(d?.UMA?.split(' ')[0] || 0, 10) || 0,
          T_MB: d?.MOBILITY?.split(' ')[3]
            ? parseInt(d?.MOBILITY?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_AT: d?.AUTECO?.split(' ')[3]
            ? parseInt(d?.AUTECO?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_SZ: d?.SUZUKI?.split(' ')[3]
            ? parseInt(d?.SUZUKI?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_HR: d?.HERO?.split(' ')[3]
            ? parseInt(d?.HERO?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_HN: d?.HONDA?.split(' ')[3]
            ? parseInt(d?.HONDA?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_OT: d?.OTRAS?.split(' ')[3]
            ? parseInt(d?.OTRAS?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_AK: d?.AKT?.split(' ')[3]
            ? parseInt(d?.AKT?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_YM: d?.YAMAHA?.split(' ')[3]
            ? parseInt(d?.YAMAHA?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
          T_UMA: d?.UMA?.split(' ')[3]
            ? parseInt(d?.UMA?.split(' ')[3].replaceAll('T', ''), 10)
            : 0,
        });
      });
      setCalculos(NewCalculos);
    }
  };

  const getMunicipioZona = async () => {
    const response = await mapsService.getMunicipiosyZonas(unidad);
    if (response) {
      setMunicipios(response);
    }
  };

  const getConsolidate = () => {
    polygonsService.getConsolidateZones(unidad).then((response) => {
      setConsolidate(response.data.data);
    });
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getZones(unidad),
      getColombia(),
      getMunicipioZona(),
      getCalculos(),
      getConsolidate(),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [unidad]);

  /*= =======================================================================
Put BigQuery
======================================================================== */
  const handleBigQuery = async () => {
    setUpdate(true);
    const body = { unidad_negocio_id: unidad };
    const response = await mapsService.putBigQuery(body);
    if (!response) {
      swal(swalMessages.WARNING_GENERAL);
    } else {
      await new Promise((resolve) => setTimeout(resolve, 20000));
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    }
    setUpdate(false);
  };

  function onEachFeature(feature, layer) {
    layer.on('mouseover', (event) => {
      event.target.openPopup();
      setEstadistica(event.target.feature.properties);
      layer.setStyle({
        fillOpacity: 1,
        weight: 3,
        dashArray: '',
      });
    });
    layer.on('mouseout', (event) => {
      event.target.closePopup();
      layer.setStyle({
        fillOpacity: 0.7,
        weight: 0,
        dashArray: '',
      });
    });
    layer.on('dblclick', (event) => {
      setShow((prev) => ({
        ...prev,
        ...event.target.feature.properties,
        show: true,
      }));
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
  }

  function mapColorBy(layer) {
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-MOBILITY') return '#000';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-YAMAHA') return '#B9B9B9';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-SUZUKI') return '#E6D97F';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-HONDA') return '#E67C7C';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-HERO') return '#83B37F';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-UMA') return '#B63429';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-AKT') return '#026FCB';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-AUTECO') return '#05305e';
    if (layer.EMPRESA_GANADORA_LOCAL === 'L-OTRAS') return '#8BF700';
    return '#fff';
  }

  function getColors(map) {
    map.eachLayer((layer) => {
      if (layer.feature) {
        const p = layer.feature.properties;
        const nombre = `${p.nombre_mpi} ${p.departamento}`;
        calculos.forEach((calculo) => {
          if (nombre == calculo.NOMBRE) {
            Object.assign(layer.feature.properties, {
              ...calculo,
            });
          }
        });
        municipios.forEach((d, index) => {
          if (p.id == d.municipio_id && check === false) {
            layer.setStyle({ color: d.color, fillColor: d.color });
            Object.assign(layer.feature.properties, {
              color: d.color,
              zona: d.zona,
              zona_id: d.zona_id,
              indexMunicipio: index,
            });
          }
          if (p.id == d.municipio_id && check === true) {
            layer.setStyle({
              color: mapColorBy(layer.feature.properties),
              fillColor: mapColorBy(layer.feature.properties),
            });
            Object.assign(layer.feature.properties, {
              color: d.color,
              zona: d.zona,
              zona_id: d.zona_id,
              indexMunicipio: index,
            });
          }
          if (p.id === show?.id && show.isDelete === true) {
            layer.setStyle({ color: 'white', fillColor: '#D0CFD4' });
            setShow((prev) => ({
              ...prev,
              isDelete: false,
            }));
          }
        });

        consolidate.forEach((c) => {
          if (c.COLOR == p.color) {
            Object.assign(layer.feature.properties, {
              jefe: c.JEFE,
              gerente: c.GERENTE,
            });
          }
        });
       layer.bindPopup(
          `<b>Nombre: ${p.nombre_mpi || 0}</b>
           <br>
           <b>Departamento: ${p.departamento || 0}</b>
           <br>
           <b>Gerente: ${p.gerente || 0}</b>
           <br>
           <b>Jefe: ${p.jefe || 0}</b>
           <br>
           <hr>
           <b>* No Personas: ${p?.CANTIDAD_DE_PERSONAS || 0}</b>
           <br>
           <b>* Zona: ${p?.zona || 0}</b>
           <br>
           <b>* Ganadora Local: ${p?.EMPRESA_GANADORA_LOCAL || 0}</b>
           <br>
           <b>* Personas en Moto: ${p?.PERSONAS_MOTOS || 0}</b>
           <br>
           <b>* Mujeres en Moto: ${p?.MUJERES_MOTOS || 0}</b>
           <br>
           <b>* Pobreza media: ${p?.POBREZA_MEDIA || 0}</b>
           <br>
           <b>* Analfabetizmo: ${p?.ANALFABETISMO_TOTAL || 0}</b>
           <br>
           <b>* Nacimiento Crítico: ${p?.HACINAMIENTO_CRITICO || 0}</b>
           <br>
           <b>* Trabajo Informal: ${p?.TRABAJO_INFORMAL || 0}</b>
           <br>
           <b>* Logro educativo: ${p?.LOGRO_EDUCATIVO || 0}</b>
           <br>
           <b>* Inasistencia Escolar: ${p?.INASISTENCIA_ESCOLAR || 0}</b>
           `
        );
      }
    });
  }

  function styleMap() {
    return {
      weight: 1,
      opacity: 1,
      color: 'white',
      fillColor: '#D0CFD4',
      fillOpacity: 0.7,
    };
  }

  function getMaps() {
    if (mapRef.current && mapRef.current.remove) {
      mapRef.current.off();
      mapRef.current.remove();
    }
    mapRef.current = L.map('map', {
      scrollWheelZoom: false,
      inertia: false,
      zoom: 6,
    }).setView([4, -74]);
    L.tileLayer(urls.MAP_LEAFLET, {
      attribution: 'Map Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
      maxZoom: 16,
    }).addTo(mapRef.current);

    L.geoJson(colombia, {
      onEachFeature,
      style: styleMap,
    }).addTo(mapRef.current);

    getColors(mapRef.current);
    mapRef.current.doubleClickZoom.disable();
  }

  useEffect(() => {
    getMaps();
  }, [colombia, municipios, calculos]);

  useEffect(() => {
    setUpdate(false);
    getColors(mapRef.current);
  }, [update]);

  const handleClose = () => {
    setShow({ show: false, info: '' });
  };

  const handleChangeZone = (params) => {
    const newMunicipiosZona = municipios;
    const indexMuncipios = newMunicipiosZona.findIndex(
      (element) => element?.municipio_id === show?.id,
    );

    const dataLake = {
      municipio_id: show?.id,
      nombre: show?.nombre_mpi,
      zona_id: params?.id,
      color: params?.color,
      zona: params?.zona,
      unidad_negocio_id: params?.unidad_negocio_id,
    };

    setShow((prev) => ({
      ...prev,
      ...dataLake,
      show: true,
    }));
    if (newMunicipiosZona[indexMuncipios] === undefined) {
      newMunicipiosZona.push(dataLake);
    } else {
      Object.assign(newMunicipiosZona[indexMuncipios], dataLake);
    }
    mapsService.putZoneCountry(dataLake);
    setUpdate(true);
  };

  const handleSelectMonth = (event) => {
    setMonth(event.target.value);
    getCalculos(event.target.value);
  };

  const handleDeleteZona = () => {
    delete municipios[show.indexMunicipio];
    setShow((prev) => ({
      ...prev,
      isDelete: true,
      show: false,
    }));
    setUpdate(true);
    mapsService.deleteZoneCountry(show, unidad);
  };

  const handleChangeColors = () => {
    setCheck(!check);
    setUpdate(true);
  };

  return (
    <>
      <MapasPage
        show={show}
        month={month}
        zonas={zonas}
        loading={loading}
        calculos={calculos}
        colombia={colombia}
        permisos={permisos}
        municipios={municipios}
        estadistica={estadistica}
        handleClose={handleClose}
        onChangeZone={handleChangeZone}
        handleBigQuery={handleBigQuery}
        handleDeleteZona={handleDeleteZona}
        handleSelectMonth={handleSelectMonth}
        handleChangeColors={handleChangeColors}
      />
    </>
  );
};

export default MapasContainer;
